function initInfoAboutGalleryPeek() {
  document.querySelectorAll('.info-about-gallery__peek-track').forEach((track) => {
    if (track.dataset.infoGalleryPeekInit === 'true') return;
    track.dataset.infoGalleryPeekInit = 'true';

    let isDragging = false;
    let startX = 0;
    let scrollStart = 0;
    let activePointerId = null;

    const finishDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      activePointerId = null;
      track.classList.remove('is-dragging');
    };

    track.addEventListener(
      'pointerdown',
      (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isDragging = true;
        activePointerId = event.pointerId;
        startX = event.clientX;
        scrollStart = track.scrollLeft;
        track.classList.add('is-dragging');
        if (typeof track.setPointerCapture === 'function') {
          track.setPointerCapture(event.pointerId);
        }
      },
      { passive: true }
    );

    track.addEventListener(
      'pointermove',
      (event) => {
        if (!isDragging || event.pointerId !== activePointerId) return;
        track.scrollLeft = scrollStart - (event.clientX - startX);
      },
      { passive: true }
    );

    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
    track.addEventListener('lostpointercapture', finishDrag);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInfoAboutGalleryPeek);
} else {
  initInfoAboutGalleryPeek();
}

document.addEventListener('shopify:section:load', initInfoAboutGalleryPeek);
